<template>
    <div>
        <v-dialog v-model="localStatus" max-width="1800px" persistent>
            <v-card>
                <v-card-title style="padding: 30px;">
                    <span class="headline">Import Multiple Invoice Files</span>
                    <v-spacer></v-spacer>
                    <v-tooltip left>
                        <template v-slot:activator="{ on, attrs }">
                            <v-chip
                                color="indigo darken-3"
                                outlined
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon right style="padding-right: 15px;padding-bottom: 2px;">
                                    {{ type.icon }}
                                </v-icon>
                                {{ type.name }}
                            </v-chip>
                        </template>
                        <span>Filename template: "COMPANY - VENDOR - INV_DATE - INV_NUM - UNIT"</span>
                    </v-tooltip>
                    <v-btn 
                        outlined
                        style="margin-left: 20px;"
                        icon
                        left
                        @click="closeDialog"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-stepper
                        v-model="stepperId"
                        vertical
                        outlined
                    >
                        <v-stepper-step
                            step="1"
                            :complete="stepperId == 2"
                        >
                            Send files to evaluate
                        </v-stepper-step>
                        <v-stepper-content step="1">
                            <v-card
                                outlined
                                class="mb-4"
                            >
                                <v-card-text>
                                    <v-file-input
                                        v-model="files"
                                        label="Select files"
                                        prepend-icon="mdi-paperclip"
                                        multiple
                                    ></v-file-input>
                                </v-card-text>
                            </v-card>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="closeDialog">Cancel</v-btn>
                                <v-btn color="blue darken-1" outlined @click="submitFiles">Submit files</v-btn>
                            </v-card-actions>
                        </v-stepper-content>

                        <v-stepper-step
                            step="2"
                            :complete="stepperId == 3"
                        >
                            Check invoice matches
                        </v-stepper-step>
                        <v-stepper-content step="2">
                            <v-card
                                outlined
                                class="mb-4"
                            >
                                <v-card-text>
                                    <v-data-table
                                        dense
                                        :headers="checkInvoice.headers"
                                        :items="checkInvoice.items"
                                        class="elevation-1"
                                    >
                                        <template v-slot:item.status="{ item }">
                                            <v-chip
                                                :color="getColor(item.status)"
                                                dense
                                                small
                                            >
                                                {{ item.status }}
                                            </v-chip>
                                        </template>
                                        <template v-slot:item.invoice_matches="{ item }">
                                            <v-menu offset-y>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                        small
                                                        dense
                                                        icon
                                                        v-bind="attrs"
                                                        v-on="on"
                                                    >
                                                        <v-icon
                                                            small
                                                        >
                                                            mdi-eye
                                                        </v-icon>
                                                    </v-btn>
                                                </template>
                                                <v-list v-if="item.matching_invoice.length" style="padding: 0;margin: 0;">
                                                    <v-list-item
                                                        v-for="(invoice, index) in item.matching_invoice"
                                                        :key="index"
                                                        @click="viewInvoice(invoice)"
                                                    >
                                                        <v-list-item-icon>
                                                            <v-icon small>mdi-invoice</v-icon>
                                                        </v-list-item-icon>
                                                        <v-list-item-title>
                                                          {{ invoice.invoice_number }}
                                                        </v-list-item-title>
                                                    </v-list-item>
                                                </v-list>
                                                <v-list v-else style="padding: 0;margin: 0;">
                                                    <v-list-item>
                                                        <v-list-item-title>
                                                            {{ item.description }} 
                                                        </v-list-item-title>
                                                    </v-list-item>
                                                </v-list>
                                            </v-menu>
                                        </template>
                                    </v-data-table>
                                </v-card-text>
                            </v-card>
                            <v-card-actions>
                                <v-btn @click="copyToClipboard" color="indigo" outlined>
                                    <v-icon left>mdi-content-copy</v-icon> Copy un-matching filenames
                                </v-btn>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="closeDialog">Cancel</v-btn>
                                <v-btn color="blue darken-1" outlined @click="uploadFiles">Upload matching files</v-btn>
                            </v-card-actions>
                        </v-stepper-content>
                    </v-stepper>
                </v-card-text>
            </v-card>
        </v-dialog>

        <InvoiceData
            v-if="invoiceData.dialogStatus"
            :invoiceDataDialogStatus="invoiceData.dialogStatus"
            :invoice="invoiceData.invoice"
            :type="type"
        ></InvoiceData>
    </div>
</template>
  
<script>
import axios from 'axios';
import InvoiceData from './InvoiceData.vue';
export default {
    props: {
        importDialogStatus: {
            type: Boolean,
            required: true
        },
        type: Object,
    },
    components: {
        InvoiceData
    },
    computed: {
    },
    mounted () {
        this.localStatus = this.importDialogStatus;
    },
    watch: {
        localStatus: function() {
            if (this.localStatus == false) {
                this.$emit('update:status', this.localStatus);
            }
        },
        importDialogStatus: function() {
            this.localStatus = this.importDialogStatus;
        }
    },
    data() {
        return {
                localStatus: false,
                files: [],
                stepperId: 1,
                checkInvoice: {
                    headers:[],
                    items: [],
                },
                invoiceData: {
                    dialogStatus: false,
                    invoice: {}
                },
                fileRelation: [],
        };
    },
    methods: {
        copyToClipboard() {
            const statuses = ['un-matching-invoice', 'incomplete-fields'];
            let items = this.checkInvoice.items.filter(item => statuses.includes(item.status));
            let strings = items.map(item => item.filename + ' --------- ' + item.status);
            let text = strings.join('\n');
            navigator.clipboard.writeText(text);
            this.$store.dispatch('setSnackbar', {
                text: 'Filenames copied to clipboard!',
                color: 'success'
            });
        },
        closeDialog() {
            this.files = [];
            this.stepperId = 1;
            this.checkInvoice = {
                headers:[],
                items: [],
            };
            this.invoiceData = {
                dialogStatus: false,
                invoice: {}
            };
            this.importDialogStatus = false;
        },
        submitFiles() {
            // Handle file submission logic here
            console.log('Files submitted:', this.files);

            if (!this.files.length) {
                this.$store.dispatch('setSnackbar', {
                    text: 'You have to upload at least 1 file.',
                    color: 'error'
                });
                return;
            }

            if (this.files.length == 50) {
                this.$store.dispatch('setSnackbar', {
                    text: 'You can upload up to 50 files.',
                    color: 'error'
                });
                return;
            }

            if (this.hasDuplicateFilenames()) {
                this.$store.dispatch('setSnackbar', {
                    text: 'Files with the same name have been found, please check.',
                    color: 'error'
                });
                return;
            }

            // reset headers
            if (this.type.axios == 'trailers' || this.type.axios == 'trucks') {
                this.checkInvoice.headers = [
                    { text: 'filename', value: 'filename' },
                    { text: 'company', value: 'company' },
                    { text: 'vendor', value: 'vendor' },
                    { text: 'invoice_number', value: 'invoice_number' },
                    { text: 'unit', value: 'unit' },
                    { text: 'invoice_matches', value: 'invoice_matches', sortable: false },
                    { text: 'status', value: 'status' },
                ];
            } else {
                this.checkInvoice.headers = [
                    { text: 'filename', value: 'filename' },
                    { text: 'company', value: 'company' },
                    { text: 'vendor', value: 'vendor' },
                    { text: 'invoice_number', value: 'invoice_number' },
                    { text: 'invoice_matches', value: 'invoice_matches', sortable: false },
                    { text: 'status', value: 'status' },
                ];
            }

            const str = this.$store;
            const formData = new FormData();
            for (let file of this.files) {
                formData.append('files[]', file);
            }
            formData.append('import_type', 'massive');
            formData.append('invoice_type', this.type.axios);

            console.log("params", formData);
            str.state.isLoading = true;
            axios
                .post(
                    '/v2/maintenance/invoices/files/evaluate', formData,
                    {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token,
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                )
                .then(response => {
                    console.log("response: ", response.data);
                    this.fileRelation = response.data;
                    for (let file of this.fileRelation) {
                        let item = {};
                        if (file.status == 'incomplete-fields') {
                            item = {
                                status: typeof file.status !== 'undefined' ? file.status : '',
                                description: typeof file.description !== 'undefined' ? file.description : '',
                                filename: typeof file.filename !== 'undefined' ? file.filename : '',
                                company: 'not found',
                                vendor: 'not found',
                                invoice_number: 'not found',
                                matching_invoice: [],
                            };
                        } else {
                            item = {
                                status: typeof file.status !== 'undefined' ? file.status : '',
                                description: typeof file.description !== 'undefined' ? file.description : '',
                                filename: typeof file.invoice_relation.filename !== 'undefined' ? file.invoice_relation.filename : '',
                                company: typeof file.invoice_relation.company !== 'undefined' ? file.invoice_relation.company : '',
                                vendor: typeof file.invoice_relation.vendor !== 'undefined' ? file.invoice_relation.vendor : '',
                                invoice_number: typeof file.invoice_relation.invoice_number !== 'undefined' ? file.invoice_relation.invoice_number : '',
                                matching_invoice: typeof file.invoice_relation.matching_invoice.invoice !== 'undefined' ? file.invoice_relation.matching_invoice.invoice : '',
                            };

                            if (this.type.axios == 'trailers' || this.type.axios == 'trucks') {
                                item.unit = typeof file.invoice_relation.unit !== 'undefined' ? file.invoice_relation.unit : '';
                            }
                        }
                        this.checkInvoice.items.push(item);
                    }

                    str.state.isLoading = false;
                    this.stepperId = 2;
                })
                .catch(error => {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        hasDuplicateFilenames() {
            const filenameCounts = {};

            for (const file of this.files) {
                const filename = file.name;

                if (filenameCounts[filename]) {
                    filenameCounts[filename]++;
                } else {
                    filenameCounts[filename] = 1;
                }

                if (filenameCounts[filename] === 2) {
                    return true;
                }
            }

            return false;
        },
        seeInvoiceMatches(invoiceMatches) {
            console.log('Invoice matches: ', invoiceMatches);
        },
        getColor (status) {
            if (status == 'matching-invoice') return 'success'
            else if (status == 'un-matching-invoice') return 'error'
            else if (status == 'incomplete-fields') return 'warning'
            else return ''
        },
        viewInvoice(invoice) {
            console.log(invoice);
            this.invoiceData.invoice = invoice;
            this.invoiceData.dialogStatus = true;
        },
        uploadFiles() {
            console.log('Upload files');
            const fileRel = this.fileRelation.filter(file => file.status == 'matching-invoice');

            if (!fileRel.length) {
                this.$store.dispatch('setSnackbar', {
                    text: 'No new matching files to upload.',
                    color: 'warning'
                });
                return;
            }

            const filenames = fileRel.map(file => file.filename);
            const filesToUpload = this.files.filter(file => filenames.includes(file.name));
            console.log('Files to upload', filesToUpload);
            console.log('Filenames', filenames);
            let fileData = [];
            for (let file of filesToUpload) {
                for (let rel of fileRel) {
                    if (file.name == rel.filename) {
                        fileData.push({
                            fileRel: rel,
                            binary: file
                        });
                        break;
                    }
                }
            }

            const str = this.$store;
            let formData = new FormData();
            formData.append('invoice_type', this.type.axios);
            fileData.forEach((item, index) => {
                formData.append('files[]', item.binary);
                formData.append(`fileRelations[${index}]`, JSON.stringify(item.fileRel));
            });

            console.log("params", formData);
            str.state.isLoading = true;
            axios
                .post(
                    '/v2/maintenance/invoices/files/upload', formData,
                    {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token,
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                )
                .then(response => {
                    console.log("response: ", response.data);
                    str.state.isLoading = false;
                    this.stepperId = 3;
                    this.$store.dispatch('setSnackbar', {
                        text: 'File upload successful.',
                        color: 'success'
                    });
                    this.closeDialog();
                })
                .catch(error => {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
    },
};
</script>
  
<style scoped>
</style>
  